import { render } from "./sepa-confrim.vue?vue&type=template&id=02a9d9da&ts=true"
import script from "./sepa-confrim.vue?vue&type=script&lang=ts"
export * from "./sepa-confrim.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__